import { useState, useEffect, useCallback } from "react";
import { jwtFetch } from "./utils/apiClient";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { config, encodeBase64RequestBody } from "./Components/Config";

const Profile = () => {
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));
  const [userKeyid, setUserKeyid] = useState('');
  const [fullName, setFullName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [userPosition, setUserPosition] = useState('');
  const [userDepartment, setUserDepartment] = useState('');
  const [userRoleDivision, setUserRoleDivision] = useState('');
  const getUser = useCallback(async () => {
    try {
      const requestUser = {
        user_keyid: crmUser.user_keyid
      };
      const fetchUser = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUser)
      });
      const responseUser = await fetchUser.json();
      if (responseUser.status === 200) {
        setUserKeyid(responseUser.data[0].user_keyid);
        setFullName(responseUser.data[0].full_name);
        setEmailAddress(responseUser.data[0].email_address);
        setUserPosition(responseUser.data[0].user_position);
        setUserDepartment(responseUser.data[0].user_department);
        setUserRoleDivision(responseUser.data[0].user_role_division);
      } else {
        alert(responseUser.message);
      }
    } catch (error) {
      console.error('Error in getUser:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }, [crmUser.user_keyid]);
  const submitUserEdit = async (e) => {
    try {
      e.preventDefault();
      const requestUserEdit = {
        "user_keyid": userKeyid,
        "full_name": fullName,
        "email_address": emailAddress,
        "user_position": userPosition,
        "user_department": userDepartment,
        "user_role_division": userRoleDivision,
      }
      const fetchUserEdit = await jwtFetch(config.ENDPOINT + 'update/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUserEdit)
      });
      const responseUserEdit = await fetchUserEdit.json();
      if (responseUserEdit.status === 200) {
        window.location.reload();
      } else {
        alert(responseUserEdit.message);
      }
    } catch (error) {
      console.error('Error in submitUserEdit:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }
  useEffect(() => {
    getUser();
  }, [getUser]);
  return (
    <div id="profile">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="dashboard" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="p-4">
              <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between bg-transparent border-0">
                      <div className="fs-28">
                        My Profile
                      </div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={submitUserEdit}>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Full Name <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required autoFocus />
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Email Address <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} required />
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Position <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <input className="form-control" type="text" value={userPosition} onChange={(e) => setUserPosition(e.target.value)} required />
                          </div>
                        </div>
                        {/* <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Department <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <select className="form-select" value={userDepartment} onChange={(e) => setUserDepartment(e.target.value)} required>
                              <option value="Sales">Sales</option>
                              <option value="Sales Admin">Sales Admin</option>
                              <option value="Finance">Finance</option>
                              <option value="Marketing">Marketing</option>
                              <option value="Delivery">Delivery</option>
                              <option value="BOD">BOD</option>
                            </select>
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-4">
                          <div className="col-md-4">
                            <label>Role <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <select className="form-select" value={userRoleDivision} onChange={(e) => setUserRoleDivision(e.target.value)} required>
                              <option value="Staff">Staff</option>
                              <option value="Senior Staff">Senior Staff</option>
                              <option value="Lead">Lead</option>
                              <option value="Manager">Manager</option>
                              <option value="Head">Head</option>
                            </select>
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-md-8 offset-md-4">
                            <button className="btn btn-primary" type="submit">Update</button>
                            <a className="btn btn-link ms-2" href="/dashboard">Cancel</a>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;


